import { setCountry } from './country-action-types';

export default function setCountryAction(country) {
  return async (dispatch) => {
    dispatch(setCountry(country || 'us'));
  };
}
